module.exports = __webpack_public_path__ + "static/media/terrain@2x.44c18676.png";